export default function MobileHeader() {
  return (
    <div
      style={{
        height: "60px",
        background: "#ffffff",
        borderBottom: "1px solid #ddd",
        display: "flex",
        alignItems: "center",
        padding: "0 15px",
        fontWeight: "bold"
      }}
    >
      MIS School Timetable
    </div>
  );
}